// extracted by mini-css-extract-plugin
module.exports = {"InputPassword":"InputPassword_InputPassword__2MyQ3","iconPassword":"InputPassword_iconPassword__3J3zB"};